// extracted by mini-css-extract-plugin
export default {"list_wrapper":"List_list_wrapper__r9dym","wrapper":"List_wrapper__MEAFM","list_group":"List_list_group__WOeNq","list_item":"List_list_item__1U9QR"};